export default "__VITE_ASSET__3f963b73__"